import {IssueType} from "../../domain/entities/issue-type.entity";

/**
 * What a /by-type row shows (D16, D54): a root row its displayed name (IssueType.toString(), the
 * translated root name) instead of the axis title the backend sends (the tenant's description); a
 * child row its own name with its root's displayed name as an overline. While the type is not loaded
 * the axis title stays, and a child whose root is not loaded gets no overline. The lookup reads the
 * loaded type cache.
 */
export function typeRowTitle(uid: string, axisTitle: string, lookup: (uid: string) => IssueType | null): {
    overline: string | null,
    title: string
} {
    const type = lookup(uid);
    if (!type) {
        return {overline: null, title: axisTitle};
    }
    if (!type.parentUid) {
        return {overline: null, title: type.toString()};
    }
    const root = lookup(type.parentUid);
    return {overline: root ? root.toString() : null, title: type.toString()};
}
